/**
 * Animates scroll position to the top when back to top button is clicked.
 */
Drupal.behaviors.backToTop = {
  attach: (context) => {
    // Add a click event to the back to top button.
    $('.back-to-top', context).on('click', (event) => {
      // Prevent any unwanted default link behavior.
      event.preventDefault();
      // Animate to the top of the page.
      $('html, body').animate({
        scrollTop: $('html').offset().top,
      }, 400);
    });
  },
};
